// extracted by mini-css-extract-plugin
module.exports = {"chart":"l_w"};